function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import CheckboxGroup from "react-checkbox-group";
import _ from "lodash";
import TmField from "./components/TmField";
import styled from "styled-components";
import { checkedImageUrl } from "../../../helpers/uiUtils";
const StyledLabel = styled.label`
  &::before {
    border-color: ${props => props.checked && !!props.color ? `${props.color} !important` : ''};
    background-color: ${props => props.checked && !!props.color ? `transparent !important` : ''};
  }
  &::after {
    background-image: ${props => props.checked && !!props.color ? checkedImageUrl(props.color) : ''}
  }
`;

class TmCheckboxGroupInput extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "handleChange", selectedOptions => {
      let result = [];

      _.chain(selectedOptions).map('id').map(option => {
        if (_.includes(result, option)) return _.pull(result, option);
        result = _.concat(result, option);
      }).value();

      this.props.onChange(result);
    });

    _defineProperty(this, "renderOptions", Checkbox => {
      return _.map(this.props.options, (option, index) => {
        return /*#__PURE__*/React.createElement("div", {
          className: `
                custom-checkbox 
                custom-control  
                ${this.props.inline ? 'custom-control-inline' : ''} 
                ${_.includes(_.map(this.props.value, 'id'), option.id) ? 'custom-control-checked' : ''}
             `,
          key: `${_.camelCase(this.props.field)}__${option.id}`
        }, /*#__PURE__*/React.createElement(StyledLabel, {
          className: "custom-control-label no-error-label",
          color: !!this.props.colors ? this.props.colors[index] : null,
          checked: _.includes(_.map(this.props.value, 'id'), option.id),
          cypress: `${this.props.cypress}_label_${_.camelCase(option.label)}`
        }, /*#__PURE__*/React.createElement(Checkbox, {
          className: "custom-control-input",
          value: option,
          checked: _.includes(_.map(this.props.value, 'id'), option.id),
          cypress: `${this.props.cypress}_checkbox_${_.camelCase(option.label)}`
        }), /*#__PURE__*/React.createElement("span", {
          style: {
            color: !!this.props.colors ? this.props.colors[index] : ''
          }
        }, option.label)));
      });
    });

    _defineProperty(this, "render", () => {
      const {
        field,
        fieldGroup
      } = this.props;
      const name = !!fieldGroup ? `${fieldGroup.replace(/\w+/g, _.capitalize)}[${_.camelCase(field)}]` : _.camelCase(field);
      return /*#__PURE__*/React.createElement(TmField, _extends({
        className: 'no-error-label'
      }, this.props), /*#__PURE__*/React.createElement("div", {
        cypress: this.props.cypress
      }, /*#__PURE__*/React.createElement(CheckboxGroup, {
        name: name,
        value: this.props.value,
        onChange: this.handleChange
      }, Checkbox => /*#__PURE__*/React.createElement(React.Fragment, null, this.renderOptions(Checkbox)))));
    });
  }

}

export default TmCheckboxGroupInput;